import {
  CASE_TYPE_SCHEMA,
  emptyValueForSchema,
  getSchemaAt,
} from "../../../case-spec";
import { isRecord } from "./shared";

const FALLBACK: Record<string, unknown> = {
  is_free: true,
  question: "",
  correct_answer: "",
  error_reply: [],
  hints: { level_1: "", level_2: "" },
};

export function emptyPuzzleStep(): Record<string, unknown> {
  const itemSchema = getSchemaAt(CASE_TYPE_SCHEMA, "game.puzzleSteps[0]");
  const empty = itemSchema ? emptyValueForSchema(itemSchema) : FALLBACK;
  if (!isRecord(empty)) return { ...FALLBACK };
  return { ...empty, is_free: true };
}
